<template>
<!-- 展商加盟 -->
<div class="ParticipationHader">
    <ParticipationHader></ParticipationHader>
    <ParticipationForm></ParticipationForm>
     <paheFooter></paheFooter>
</div>
</template>
<script>
// 引入展商加盟的头部
import ParticipationHader from '@/common/Participation/Participation-hader.vue'
// 引入展商加盟的表单
import ParticipationForm from '@/common/Participation/Participation-form.vue'
//引入底部
import paheFooter from '@/common/index/pahe-footer'
export default {
    name:"Participation",
    components:{
        paheFooter,
        ParticipationHader,
        ParticipationForm
    }
}
</script>
<style scoped>
.ParticipationHader{
    background: #f9f9f9;
}
</style>


// WEBPACK FOOTER //
// src/components/Participation.vue